/**
 * Greek Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const el: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Πίνακας ελέγχου',
  'nav.funds': 'Ταμεία',
  'nav.investments': 'Επενδύσεις',
  'nav.investees': 'Αποδέκτες επενδύσεων',
  'nav.esg': 'ESG Αξιολόγηση',
  'nav.compliance': 'Συμμόρφωση',
  'nav.reports': 'Αναφορές',
  'nav.settings': 'Ρυθμίσεις',
  'nav.users': 'Χρήστες',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Δείκτες',
  'nav.taxonomy': 'Ταξινομία ΕΕ',
  'nav.filings': 'Υποβολές',
  'nav.calendar': 'Ημερολόγιο',
  'nav.submit': 'Υποβολή δεδομένων',
  'nav.submissions': 'Οι υποβολές μου',
  'nav.benchmarks': 'Δείκτες αναφοράς',
  'nav.messages': 'Μηνύματα',
  'nav.portfolio': 'Χαρτοφυλάκιο',
  'nav.performance': 'Απόδοση ταμείων',
  'nav.esgSummary': 'ESG Σύνοψη',
  'nav.pipeline': 'Αγωγός',
  'nav.dueDiligence': 'Due Diligence',
  'nav.impact': 'Δείκτες αντίκτυπου',
  'nav.sdg': 'Χαρτογράφηση ΣΒΑ',
  'nav.audit': 'Ίχνος ελέγχου',
  'nav.snapshots': 'Στιγμιότυπα δεδομένων',
  'nav.knowledgeGraph': 'Γράφος γνώσης',
  'nav.geographic': 'Γεωγραφικό',
  'nav.bi': 'BI Studio',
  'nav.ai': 'AI Βοηθός',
  'nav.tasks': 'Εργασίες',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Ρυθμιστική παρακολούθηση',

  // Common Actions
  'action.create': 'Δημιουργία',
  'action.edit': 'Επεξεργασία',
  'action.delete': 'Διαγραφή',
  'action.save': 'Αποθήκευση',
  'action.cancel': 'Ακύρωση',
  'action.submit': 'Υποβολή',
  'action.approve': 'Έγκριση',
  'action.reject': 'Απόρριψη',
  'action.download': 'Λήψη',
  'action.export': 'Εξαγωγή',
  'action.import': 'Εισαγωγή',
  'action.filter': 'Φίλτρο',
  'action.search': 'Αναζήτηση',
  'action.refresh': 'Ανανέωση',
  'action.close': 'Κλείσιμο',
  'action.back': 'Πίσω',
  'action.next': 'Επόμενο',
  'action.previous': 'Προηγούμενο',
  'action.viewAll': 'Προβολή όλων',
  'action.viewDetails': 'Προβολή λεπτομερειών',
  'action.generate': 'Δημιουργία',
  'action.signOut': 'Αποσύνδεση',
  'action.addNew': 'Προσθήκη νέου',
  'action.invite': 'Πρόσκληση',

  // Statuses
  'status.draft': 'Πρόχειρο',
  'status.submitted': 'Υποβλήθηκε',
  'status.validated': 'Επικυρώθηκε',
  'status.approved': 'Εγκρίθηκε',
  'status.rejected': 'Απορρίφθηκε',
  'status.pending': 'Εκκρεμεί',
  'status.inProgress': 'Σε εξέλιξη',
  'status.overdue': 'Εκπρόθεσμο',
  'status.compliant': 'Συμμορφούμενο',
  'status.filed': 'Υποβλήθηκε',
  'status.active': 'Ενεργό',
  'status.inactive': 'Ανενεργό',
  'status.closed': 'Κλειστό',
  'status.fundraising': 'Συγκέντρωση κεφαλαίων',
  'status.investing': 'Επένδυση',
  'status.harvesting': 'Συγκομιδή',
  'status.validating': 'Επικύρωση',
  'status.review': 'Σε εξέταση',
  'status.monitoring': 'Παρακολούθηση',
  'status.exiting': 'Έξοδος',
  'status.pipeline': 'Pipeline',
  'status.due_diligence': 'Δέουσα επιμέλεια',
  'status.disbursed': 'Εκταμιευμένο',
  'status.restructured': 'Αναδιαρθρωμένο',
  'status.matured': 'Ωρίμασε',
  'status.written_off': 'Διαγραμμένο',
  'status.exited': 'Εξήλθε',
  'status.incomplete': 'Ημιτελές',
  'status.open': 'Ανοικτό',
  'status.in_progress': 'Σε εξέλιξη',
  'status.completed': 'Ολοκληρωμένο',
  'status.cancelled': 'Ακυρωμένο',
  'status.accepted': 'Αποδεκτό',
  'status.failed': 'Αποτυχία',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Επισκόπηση χαρτοφυλακίου',
  'dashboard.complianceStatus': 'Κατάσταση συμμόρφωσης',
  'dashboard.collectionProgress': 'Πρόοδος συλλογής',
  'dashboard.activityFeed': 'Δραστηριότητα',
  'dashboard.quickActions': 'Γρήγορες ενέργειες',
  'dashboard.investmentPipeline': 'Αγωγός επενδύσεων',
  'dashboard.totalFunds': 'Σύνολο ταμείων',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Ενεργές επενδύσεις',
  'dashboard.totalInvestees': 'Αποδέκτες επενδύσεων',
  'dashboard.recentActivity': 'Πρόσφατη δραστηριότητα',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Σύνολο δεσμεύσεων',
  'lp.capitalCalled': 'Κληθέν κεφάλαιο',
  'lp.distributed': 'Διανεμηθέν',
  'lp.netPosition': 'Καθαρή θέση',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Απόδοση ταμείων',
  'lp.esgSummary': 'ESG Σύνοψη',
  'lp.reportLibrary': 'Βιβλιοθήκη αναφορών',
  'lp.taxonomyAligned': 'Ευθυγραμμισμένο με ταξινομία',
  'lp.paiCoverage': 'PAI Κάλυψη',
  'lp.portfolioPerformance': 'Απόδοση χαρτοφυλακίου LP',

  // Fund Labels
  'fund.name': 'Όνομα ταμείου',
  'fund.code': 'Κωδικός ταμείου',
  'fund.vintage': 'Έτος ίδρυσης',
  'fund.size': 'Μέγεθος ταμείου',
  'fund.targetSize': 'Στόχος μεγέθους',
  'fund.currency': 'Νόμισμα',
  'fund.strategy': 'Στρατηγική',
  'fund.status': 'Κατάσταση',
  'fund.sfdrCategory': 'SFDR Κατηγορία',
  'fund.geographyFocus': 'Γεωγραφική εστίαση',
  'fund.sectorFocus': 'Τομεακή εστίαση',

  // Form Labels
  'form.name': 'Όνομα',
  'form.email': 'Email',
  'form.country': 'Χώρα',
  'form.amount': 'Ποσό',
  'form.currency': 'Νόμισμα',
  'form.date': 'Ημερομηνία',
  'form.description': 'Περιγραφή',
  'form.notes': 'Σημειώσεις',
  'form.type': 'Τύπος',
  'form.period': 'Περίοδος',
  'form.year': 'Έτος',
  'form.required': 'Υποχρεωτικό',
  'form.optional': 'Προαιρετικό',

  // Table Headers
  'table.fund': 'Ταμείο',
  'table.commitment': 'Δέσμευση',
  'table.called': 'Κληθέν',
  'table.distributed': 'Διανεμηθέν',
  'table.tvpi': 'TVPI',
  'table.status': 'Κατάσταση',
  'table.regulation': 'Κανονισμός',
  'table.filingType': 'Τύπος υποβολής',
  'table.reportingPeriod': 'Περίοδος',
  'table.createdAt': 'Δημιουργήθηκε',
  'table.actions': 'Ενέργειες',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Ταξινομία ΕΕ',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Πληρότητα δεδομένων',
  'compliance.nextDeadline': 'Επόμενη προθεσμία',

  // Reports
  'report.quarterly': 'Τριμηνιαία αναφορά',
  'report.annual': 'Ετήσια αναφορά',
  'report.paiStatement': 'PAI Δήλωση',
  'report.taxonomyReport': 'Αναφορά ταξινομίας',
  'report.generatedAt': 'Δημιουργήθηκε',
  'report.version': 'Έκδοση',

  // General
  'general.loading': 'Φόρτωση...',
  'general.noData': 'Δεν υπάρχουν διαθέσιμα δεδομένα',
  'general.error': 'Παρουσιάστηκε σφάλμα',
  'general.retry': 'Δοκιμάστε ξανά',
  'general.total': 'Σύνολο',
  'general.page': 'Σελίδα',
  'general.of': 'από',
  'general.showing': 'Εμφάνιση',
  'general.results': 'αποτελέσματα',
  'general.language': 'Γλώσσα',
  'general.english': 'Αγγλικά',
  'general.french': 'Γαλλικά',

  // Tour
  'tour.takeTour': 'Ξεκινήστε την ξενάγηση',
  'tour.skip': 'Παράλειψη',
  'tour.next': 'Επόμενο',
  'tour.prev': 'Προηγούμενο',
  'tour.finish': 'Τέλος',


  // Tour Content, Form Labels, Table Headers, Actions, Errors (i18n wiring)
  'tour.sidebarTitle': 'Πλοήγηση',
  'tour.sidebarContent': 'Χρησιμοποιήστε την πλαϊνή μπάρα για πλοήγηση μεταξύ διαχείρισης χαρτοφυλακίου, συλλογής δεδομένων ESG, συμμόρφωσης, αναφορών και εργαλείων ανάλυσης.',
  'tour.kpisTitle': 'Επισκόπηση χαρτοφυλακίου',
  'tour.kpisContent': 'Αυτές οι κάρτες δείχνουν το χαρτοφυλάκιό σας με μια ματιά — συνολικά κεφάλαια, AUM, ενεργές επενδύσεις και αριθμός εταιρειών.',
  'tour.actionsTitle': 'Γρήγορες ενέργειες',
  'tour.actionsContent': 'Δημιουργήστε κεφάλαια, προσθέστε επενδύσεις, προσκαλέστε εταιρείες και δημιουργήστε αναφορές με ένα κλικ.',
  'tour.languageTitle': 'Γλώσσα',
  'tour.languageContent': 'Εναλλαγή μεταξύ 24 επίσημων γλωσσών της ΕΕ. Ολόκληρη η διεπαφή μεταφράζεται αμέσως.',
  'tour.aiTitle': 'Βοηθός AI',
  'tour.aiContent': 'Κάντε ερωτήσεις για το χαρτοφυλάκιό σας ανά πάσα στιγμή. Ο βοηθός AI έχει πλήρη πληροφόρηση για τα κεφάλαιά σας.',
  'action.createFund': 'Δημιουργία κεφαλαίου',
  'action.editFund': 'Επεξεργασία κεφαλαίου',
  'action.addInvestment': 'Προσθήκη επένδυσης',
  'action.addInvestee': 'Προσθήκη εταιρείας',
  'action.editInvestee': 'Επεξεργασία εταιρείας',
  'action.createTemplate': 'Δημιουργία προτύπου',
  'action.createSubmission': 'Δημιουργία υποβολής',
  'action.createFiling': 'Δημιουργία υποβολής',
  'action.generateReport': 'Δημιουργία αναφοράς',
  'action.inviteUser': 'Πρόσκληση χρήστη',
  'action.sendInvitation': 'Αποστολή πρόσκλησης',
  'action.saveChanges': 'Αποθήκευση αλλαγών',
  'form.fundName': 'Όνομα κεφαλαίου',
  'form.fundCode': 'Κωδικός κεφαλαίου',
  'form.sfdrCategory': 'Κατηγορία SFDR',
  'form.baseCurrency': 'Βασικό νόμισμα',
  'form.targetSize': 'Μέγεθος-στόχος',
  'form.vintageYear': 'Έτος ίδρυσης',
  'form.geographyFocus': 'Γεωγραφική εστίαση',
  'form.sectorFocus': 'Τομεακή εστίαση',
  'form.investmentCode': 'Κωδικός επένδυσης',
  'form.instrumentType': 'Τύπος μέσου',
  'form.maturityDate': 'Ημερομηνία λήξης',
  'form.sector': 'Τομέας',
  'form.countryCode': 'Κωδικός χώρας',
  'form.entityType': 'Τύπος οντότητας',
  'form.region': 'Περιοχή',
  'form.staffCount': 'Αριθμός υπαλλήλων',
  'form.borrowers': 'Δανειολήπτες',
  'form.contactName': 'Όνομα επαφής',
  'form.contactEmail': 'E-mail επαφής',
  'form.templateName': 'Όνομα προτύπου',
  'form.templateType': 'Τύπος προτύπου',
  'form.indicators': 'Δείκτες',
  'form.reportingPeriod': 'Περίοδος αναφοράς',
  'form.reportingYear': 'Έτος αναφοράς',
  'form.regulation': 'Κανονισμός',
  'form.filingType': 'Τύπος υποβολής',
  'form.reportType': 'Τύπος αναφοράς',
  'form.emailAddress': 'Διεύθυνση e-mail',
  'form.role': 'Ρόλος',
  'form.selectFund': 'Επιλέξτε κεφάλαιο...',
  'form.selectInvestee': 'Επιλέξτε εταιρεία...',
  'table.code': 'Κωδικός',
  'table.investee': 'Εταιρεία',
  'table.instrument': 'Μέσο',
  'table.amount': 'Ποσό',
  'table.currency': 'Νόμισμα',
  'table.maturity': 'Λήξη',
  'table.name': 'Όνομα',
  'table.country': 'Χώρα',
  'table.type': 'Τύπος',
  'table.period': 'Περίοδος',
  'table.completion': 'Ολοκλήρωση',
  'table.submitted': 'Υποβλήθηκε',
  'table.version': 'Έκδοση',
  'table.indicators': 'Δείκτες',
  'table.dueDate': 'Προθεσμία',
  'table.generated': 'Δημιουργήθηκε',
  'table.email': 'E-mail',
  'table.role': 'Ρόλος',
  'error.createFailed': 'Αποτυχία δημιουργίας. Δοκιμάστε ξανά.',
  'error.updateFailed': 'Αποτυχία ενημέρωσης. Δοκιμάστε ξανά.',
  'error.loadFailed': 'Αποτυχία φόρτωσης δεδομένων.',

  // Sidebar Sections
  'sections.portfolio': 'ΧΑΡΤΟΦΥΛΑΚΙΟ',
  'sections.dataCollection': 'ΣΥΛΛΟΓΗ ΔΕΔΟΜΕΝΩΝ',
  'sections.intelligence': 'ΠΛΗΡΟΦΟΡΙΕΣ',
  'sections.ecosystem': 'ΟΙΚΟΣΥΣΤΗΜΑ',
  'sections.admin': 'ΔΙΑΧΕΙΡΙΣΗ',
  'sections.other': 'ΑΛΛΟ',

  // Page Titles
  'pages.messagesTitle': 'Μηνύματα',
  'pages.taxonomyTitle': 'Ταξινομία ΕΕ',
  'pages.biStudioTitle': 'BI Studio',
  'pages.knowledgeGraphTitle': 'Γράφος Γνώσης',
  'pages.benchmarksTitle': 'Δείκτες Αναφοράς',
  'pages.mcpTitle': 'Ενσωμάτωση MCP',
  'pages.tasksTitle': 'Εργασίες',
  'pages.submitDataTitle': 'Υποβολή δεδομένων ESG',

  // Empty States
  'empty.benchmarksComingSoon': 'Δείκτες αναφοράς σύντομα',

  // Labels
  'labels.sfdr': 'SFDR',
  'labels.euTaxonomy': 'Ταξινομία ΕΕ',
  'labels.csrd': 'CSRD',
  'labels.mifid': 'MiFID',
  'labels.other': 'Άλλο',
  'labels.critical': 'Κρίσιμο',
  'labels.high': 'Υψηλό',
  'labels.medium': 'Μέτριο',
  'labels.low': 'Χαμηλό',

  // Count / summary strings
  'count.fundsTotal': '{count} fund(s) total',
  'count.investmentsTotal': '{count} investment(s) total',
  'count.investeesTotal': '{count} investee(s) total',

  // Filter options
  'filter.allStatus': 'All Status',
  'filter.allSfdr': 'All SFDR',

  // Empty states
  'empty.noFundsYet': 'No funds yet. Create your first fund.',
  'empty.noFundsMatch': 'No funds match your filters.',
  'empty.noInvestmentsYet': 'No investments yet.',
  'empty.noInvestmentsMatch': 'No investments match your search.',
  'empty.noInvesteesYet': 'No investees yet.',
  'empty.noInvesteesMatch': 'No investees match your search.',
  'empty.noTemplatesYet': 'No ESG templates configured yet.',
  'empty.noSubmissionsYet': 'No ESG submissions yet.',
  'empty.noComplianceData': 'No SFDR compliance data available.',
  'empty.noFilingsYet': 'No compliance filings yet.',
  'empty.noReportsYet': 'No reports generated yet.',
  'empty.selectFundPai': 'Select a fund to view PAI indicators.',
  'empty.noPaiIndicators': 'No PAI indicators found for this fund.',
  'empty.selectFundCalendar': 'Select a fund to view compliance calendar.',
  'empty.noCalendarEvents': 'No upcoming events for this fund.',

  // Page subtitles
  'subtitle.esg': 'Templates and data submissions',
  'subtitle.compliance': 'SFDR, PAI indicators, and regulatory filings',
  'subtitle.reports': 'Generate and manage compliance reports',
  'subtitle.settings': 'Manage your account and preferences',

  // Tab labels
  'tab.templates': 'Templates',
  'tab.submissions': 'Submissions',
  'tab.sfdr': 'SFDR',
  'tab.paiIndicators': 'PAI Indicators',
  'tab.filings': 'Filings',
  'tab.reports': 'Reports',
  'tab.calendar': 'Calendar',

  // Compliance table headers
  'table.indicator': 'Indicator',
  'table.category': 'Category',
  'table.metric': 'Metric',
  'table.value': 'Value',
  'table.mandatory': 'Mandatory',
  'table.data': 'Data',
  'table.deadline': 'Deadline',
  'table.taxonomy': 'Taxonomy',

  // Yes/No
  'general.yes': 'Yes',
  'general.no': 'No',

  // Error messages
  'error.loadTemplates': 'Failed to load templates.',
  'error.loadSubmissions': 'Failed to load submissions.',
  'error.loadCompliance': 'Failed to load compliance data.',
  'error.loadPai': 'Failed to load PAI indicators.',
  'error.loadFilings': 'Failed to load filings.',
  'error.loadCalendar': 'Failed to load calendar events.',
  'error.createTemplate': 'Failed to create template. Please try again.',
  'error.createSubmission': 'Failed to create submission. Please try again.',
  'error.createFiling': 'Failed to create filing. Please try again.',
  'error.generateReport': 'Failed to generate report.',
  'error.templateNameRequired': 'Template name is required',
  'error.selectFund': 'Select a fund',
  'error.selectInvestee': 'Select an investee',
  'error.validAmount': 'Enter a valid amount',
  'error.reportingPeriodRequired': 'Reporting period is required',
  'error.validYearRequired': 'Valid year is required',
  'error.enterPeriod': 'Enter a period',
  'error.nameRequired': 'Name is required',
  'error.countryCodeRequired': 'Country code is required',
  'error.operationFailed': 'Operation failed.',
  'error.pleaseselectFund': 'Please select a fund',

  // Success messages
  'success.submissionCreated': 'Submission created successfully.',
  'success.profileSaved': 'Profile saved successfully.',

  // Relative time
  'time.justNow': 'Just now',
  'time.minutesAgo': '{count}m ago',
  'time.hoursAgo': '{count}h ago',
  'time.daysAgo': '{count}d ago',

  // Settings
  'settings.profile': 'Profile',
  'settings.organization': 'Organization',
  'settings.apiKeys': 'API Keys',
  'settings.notifications': 'Notifications',
  'settings.orgId': 'Org ID',
  'settings.tier': 'Tier',
  'settings.apiKeysDescription': 'Contact your organization administrator to manage API keys and integration credentials.',
  'settings.apiKeysNote': 'API keys provide programmatic access to Impact Core data. For security, key creation and revocation is restricted to organization admins.',
  'settings.notifReportAlerts': 'Report generation alerts',
  'settings.notifReportAlertsDesc': 'Email when a report is generated or fails',
  'settings.notifComplianceReminders': 'Compliance deadline reminders',
  'settings.notifComplianceRemindersDesc': 'Email reminders for upcoming filing deadlines',
  'settings.notifEsgUpdates': 'ESG submission updates',
  'settings.notifEsgUpdatesDesc': 'Email when investee submissions change status',
  'settings.notifInAppActivity': 'In-app activity feed',
  'settings.notifInAppActivityDesc': 'Show real-time activity notifications in header',

  // Data Completeness label
  'compliance.dataCompletenessLabel': 'Data Completeness',
};
